
export const REF_REQUEST = 'REF_REQUEST'
export const REF_SUCCESS = 'REF_SUCCESS'
export const REF_FAILURE = 'REF_FAILURE'
